import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Monogram from "../components/Monogram";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const signInWithGoogle = () => {
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Login() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div data-testid="login-loading" className="min-h-screen bg-ink flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-gold" />
      </div>
    );
  }

  if (user) return <Navigate to="/admin" replace />;

  return (
    <div
      data-testid="login-page"
      className="min-h-screen bg-ink text-ivory font-body flex items-center justify-center px-4"
    >
      <div className="w-full max-w-md border border-white/[0.08] bg-ink-soft/60 p-8 sm:p-12 text-center">
        <Monogram className="w-14 h-14 text-gold mx-auto mb-6" />
        <h1 className="font-display text-3xl mb-2 text-ivory">Studio Login</h1>
        <p className="text-sm text-ivory-dim leading-relaxed mb-9">
          For Mohit & the team — sign in to read booking enquiries
          from the website.
        </p>
        <button
          data-testid="google-signin-btn"
          onClick={signInWithGoogle}
          className="w-full flex items-center justify-center gap-3 bg-white text-[#1F1F1F] text-sm font-medium py-4 hover:bg-ivory hover:-translate-y-0.5 transition-all duration-300"
        >
          <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden="true">
            <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
            <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z" />
            <path fill="#FBBC05" d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z" />
            <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09c.95-2.85 3.6-4.96 6.73-4.96z" />
          </svg>
          Continue with Google
        </button>
        <p className="text-[11px] text-ivory-mute mt-8 tracking-[0.2em] uppercase">
          Every Moment. Forever Framed.
        </p>
      </div>
    </div>
  );
}
